import React, { Component } from 'react';

import classNames from 'classnames';
import { DataTable } from 'components/dataTable';
import { inject, observer } from 'mobx-react';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import { commentDataProptype } from 'modules/community/commentList/DataPropType';
import { COLUMNS_LIST } from 'modules/community/constants';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import CommentListTableBody from './CommentListTableBody';
import CommentListTableHeader from './CommentListTableHeader';

import './CommentListTable.scss';

const emptyList = {
  label: 'community.empty_comments_message',
  icon: 'icon-empty'
};

@inject((stores) => ({
  hash: stores.UserStore.hash,
  page: stores.CommunityStore.page,
  perPage: stores.CommunityStore.perPage,
  totalElements: stores.CommunityStore.totalElements,
  selectAll: stores.CommunityStore.selectAll
}))
@observer
export default class CommentListTable extends Component {
  static propTypes = {
    fetchCommentsData: PropTypes.func,
    onChangeSort: PropTypes.func,
    comments: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape(commentDataProptype)),
      PropTypes.object
    ]),
    hash: PropTypes.string,
    label: PropTypes.object,
    classesList: PropTypes.array,
    getUserComments: PropTypes.func,
    loading: PropTypes.bool,
    page: PropTypes.number,
    perPage: PropTypes.number,
    totalElements: PropTypes.number,
    selectAll: PropTypes.bool,
    activedTab: PropTypes.number
  };

  state = {
    answerListText: {},
    answerListOpened: {}
  };

  columns = Object.values(COLUMNS_LIST);
  dataTableRef = React.createRef();

  constructor(props) {
    super(props);

    this.updateItems = this.updateItems.bind(this);
    this.updateNotifications = this.updateNotifications.bind(this);
    this.getUserComments = this.getUserComments.bind(this);
    this.openAnswerBox = this.openAnswerBox.bind(this);
    this.closeAnswerBox = this.closeAnswerBox.bind(this);
    this.onAnswerText = this.onAnswerText.bind(this);
    this.commentAnswerReply = this.commentAnswerReply.bind(this);
    this.fetchItems = this.fetchItems.bind(this);
  }

  componentDidMount() {
    this.updateItems();
  }

  updateItems(page) {
    if (this.dataTableRef && this.dataTableRef.current) {
      this.dataTableRef.current.updateItems(page);
    }
  }

  fetchItems(dataTableParams) {
    const { fetchCommentsData } = this.props;

    CommunityService.setData({ dataTableParams });

    fetchCommentsData(CommunityService.commentListParams);
  }

  updateNotifications({ selectAll, checked, item }) {
    const { comments } = this.props;

    if (item) {
      CommunityService.checkCommentByItem(item, checked);
    } else {
      CommentListService.updateSelectedComments(comments, selectAll);
    }

    CommunityService.setSelectAll(selectAll);

    this.setState({ selectAll });
  }

  onAnswerText(event, item) {
    const { answerListText } = this.state;
    const { value } = event.target;
    const newAnswerListText = Object.assign({}, answerListText);

    newAnswerListText[item.id] = value;

    this.setState({ answerListText: newAnswerListText });
  }

  openAnswerBox(item) {
    const { answerListOpened } = this.state;
    const newAnswerListOpened = Object.assign({}, answerListOpened);

    if (!newAnswerListOpened[item.id]) {
      newAnswerListOpened[item.id] = true;

      this.setState({ answerListOpened: newAnswerListOpened });
    }
  }

  closeAnswerBox(item) {
    const { answerListOpened, answerListText } = this.state;
    const newAnswerListText = Object.assign(answerListText, {});
    const newAnswerListOpened = Object.assign(answerListOpened, {});

    if (newAnswerListOpened[item.id]) {
      newAnswerListOpened[item.id] = false;
      newAnswerListText[item.id] = '';

      this.setState({
        answerListOpened: newAnswerListOpened,
        answerListText: newAnswerListText
      });
    }
  }

  async getUserComments() {
    const { fetchCommentsData } = this.props;

    await fetchCommentsData(CommunityService.commentListParams);
  }

  async commentAnswerReply(answerData) {
    const { hash: userId } = this.props;
    const { answerListText } = this.state;

    const commentId = answerData.id;
    const commentUserId = answerData.user.id;
    const content = answerListText[answerData.id];

    const response = await CommunityService.commentAnswerReply(
      userId,
      commentUserId,
      commentId,
      content
    );

    if (response) {
      await this.getUserComments();
      CommunityService.getCommunityNotifications();

      UiService.setAlertSuccess('community.send_notification_message_success');
    }

    this.closeAnswerBox(answerData);
  }

  resetSelectAll = () => {
    CommunityService.setSelectAll(false);
  };

  render() {
    const {
      comments,
      onChangeSort,
      label,
      loading,
      page,
      perPage,
      totalElements,
      fetchCommentsData,
      selectAll = false,
      activedTab
    } = this.props;
    const { answerListText, answerListOpened } = this.state;

    const pagination = { page, perPage, totalElements };
    const columns = this.columns;
    const dataTableClass = classNames(
      'comment-list__data-table _text-gray-700',
      {
        'comment-list-table--loading': loading
      }
    );

    return (
      <DataTable
        key="data-table"
        className={dataTableClass}
        columns={columns}
        fetchItems={this.fetchItems}
        items={comments}
        pagination={pagination}
        ref={this.dataTableRef}
        onSelect={this.updateNotifications}
        onChangeSort={onChangeSort}
        emptyList={emptyList}
        loading={loading}
        onChangePage={this.resetSelectAll}
        selectAll={selectAll}
      >
        <CommentListTableHeader />

        <CommentListTableBody
          fetchCommentsData={fetchCommentsData}
          comments={comments}
          columns={columns}
          answerListText={answerListText}
          answerListOpened={answerListOpened}
          label={label}
          getUserComments={this.getUserComments}
          openAnswerBox={this.openAnswerBox}
          closeAnswerBox={this.closeAnswerBox}
          onAnswerText={this.onAnswerText}
          commentAnswerReply={this.commentAnswerReply}
          activedTab={activedTab}
        />

        <DataTable.Footer className="comment-list__footer" />
      </DataTable>
    );
  }
}
